import {
  AutoComplete,
  FormContainer,
  Treturn,
  useFetch,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import MainApiService from "../../../../../../services/mainApi.service";
import {
  createMarComAutomationList,
  getMarComAutomationListById,
  updateMarComAutomationList,
} from "../../../../../../services/marComAutomationLists.service";
import { IList } from "../../../../../../models/lists";
import {
  distributionListSchema,
  TDistributionListsForm,
} from "./distributionListSchema";
import { IMarComAutomationListProps } from "./models";

const translationPath =
  "page.4uMarCom.automationRules.marcom_distributionList.";

const LIST_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/List/";
const listService = new MainApiService<IList>(LIST_ROUTE);

export const DistributionList = memo(
  ({
    id,
    marComAutomationRuleId,
    onBackButton,
  }: IMarComAutomationListProps) => {
    const { t } = useTranslation();

    const { sendRequest: save, loading: sLoading } = useFetch(
      createMarComAutomationList
    );

    const { sendRequest: update, loading: uLoading } = useFetch(
      updateMarComAutomationList
    );

    const { sendRequest: get, loading: gLoading } = useFetch(
      getMarComAutomationListById
    );

    const updateHandler = (v: TDistributionListsForm, id: string) =>
      update({
        item: {
          id: id,
          marComAutomationRuleId: marComAutomationRuleId ?? "",
          listId: v.list.id,
        },
        id: id,
      });

    const saveHandler = (v: TDistributionListsForm) =>
      save({
        marComAutomationRuleId: marComAutomationRuleId ?? "",
        listId: v.list.id,
      });

    const getHandler = useCallback(
      async (id: string): Promise<Treturn<TDistributionListsForm>> => {
        const { data, success } = await get(id);

        if (data) {
          const newData: TDistributionListsForm = {
            ...data,
            list: data.list,
          };
          return { data: newData, success: true };
        }
        return { data, success };
      },
      [get]
    );
    const successHandle = () => {
      onBackButton();
    };
    const loading = sLoading || uLoading || gLoading;
    return (
      <FormContainer<TDistributionListsForm>
        saveFunction={saveHandler}
        updateFunction={updateHandler}
        getFunction={getHandler}
        loading={loading}
        title={t(translationPath + "title")}
        schema={distributionListSchema}
        subtitle={t(translationPath + "new")}
        backButtonOnClick={onBackButton}
        redirectOnSave={false}
        onSuccess={successHandle}
        isModalForm={true}
        propId={id}
        formActionsOnBottom={false}
        fields={() => (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <AutoComplete
                getOptionLabel={({ name }) => name}
                size="small"
                label={t(translationPath + "list")}
                name="list"
                request={listService.list}
                clearIcon={false}
              />
            </Grid>
          </Grid>
        )}
      />
    );
  }
);
